import React, { useEffect, useState } from 'react';
import classes from './Report.module.css';
import BoxWrapper from '../../../../../components/ui/boxWrapper';

function UnRegisteRcm( {onTabClick,unregisterrcm}) {
    useEffect(() => {
      onTabClick();
    }, [onTabClick]);
    const unregisteredata = unregisterrcm?.record?.unregisteredRCM ?? []
  return (
     <>
      <BoxWrapper
        searchInputPlaceholder="Search..."
        boxTitle="UnRegistered RCM"
      >

<div className={classes.ResponsiveTable}>
        <table className={classes.missingInAccountTableCss}>
          {/* Table header */}
          <thead>
       
            <tr>
              <th style={{ color: "black" }} >GSTIN</th>
              <th style={{ color: "black" }} >VENDOR NAME</th>
              <th style={{ color: "black" }} >DOC NUMBER</th>
              <th style={{ color: "black" }} >DOC DATE</th>
              <th style={{ color: "black" }} >DOC TYPE</th>
              <th style={{ color: "black" }} >TOTAL AMOUNT</th>
              <th style={{ color: "black" }} >TAXABLE VALUE</th>
              <th style={{ color: "black" }} >CGST</th>
              <th style={{ color: "black" }} >SGST</th>
              <th style={{ color: "black" }} >IGST</th>
              <th style={{ color: "black" }} >CESS</th>
       
            </tr>
          </thead>
          {/* Table body */}
          <tbody>
            {unregisteredata.map((invoice, index) => (
              <tr key={index}>
                <td style={{ color: "black" }}>{invoice.GSTIN}</td>
                <td style={{ color: "black" }}>{invoice.Vendor_Name}</td>
                <td style={{ color: "black" }}>{invoice.DOC_NUMBER}</td>
                <td style={{ color: "black" }}>{invoice.DOC_DATE}</td>
                <td style={{ color: "black" }}>{invoice.DOC_TYPE}</td>
                <td style={{ color: "black" }}>{invoice.Total_Amount}</td>
                <td style={{ color: "black" }}>{invoice.Taxable_Value}</td>
                <td style={{ color: "black" }}>{invoice.CGST}</td>
                <td style={{ color: "black" }}>{invoice.SGST}</td>
                <td style={{ color: "black" }}>{invoice.IGST}</td>
                <td style={{ color: "black" }}>{invoice.Cess}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </BoxWrapper>
     </>
  );
}

export default UnRegisteRcm;
